import React, { useState, useEffect, useCallback } from "react"
import axiosConfig from "../Service/axiosConfig"
import { useScrollContext } from "../Utils/ScrollContext";
import { NavLink, useNavigate } from "react-router-dom";
import projectTypeUtils from '../Utils/ProjectType';
import { MdOutlineMoreVert, MdOutlineRemoveRedEye, MdOutlineWatchLater } from 'react-icons/md';
import timeAgo from "../Utils/TimeAgo";
import { Requirementcontent } from "./RequirementContent";
const ProfileRequirement = ({ ProfileData, can_edit_profile }) => {
    const { getProjectType, getProjectTypeColor } = projectTypeUtils
    const [Data, SetData] = useState([]);
    const [nextUrl, setNextUrl] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const { registerLoadMore } = useScrollContext();
    const navigate = useNavigate();
    const GetData = async () => {
        setLoading(true);
        try {
            const response = await axiosConfig.get(
                `/accounts/audition-requirements/?approval_status=approved&requirement_status=live`
            );
            SetData(response.data.results);
            setNextUrl(response.data.next);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };
    const handleInfiniteScroll = useCallback(async () => {
        if (loadingMore || !nextUrl) return;

        setLoadingMore(true);
        try {
            const resp = await axiosConfig.get(nextUrl);
            SetData((prev) => [...prev, ...resp.data.results]);
            setNextUrl(resp.data.next);
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingMore(false);
        }
    }, [loadingMore, nextUrl]);
    const handleApply = (id) => {
        axiosConfig.post("/accounts/audition-applications/", { audition_requirement: id, profile: ProfileData.id }).then(res => {
            console.log(res);
        }).catch(error => {
            console.log(error);
        });
    };
    useEffect(() => {
        if (ProfileData?.id) {
            GetData();
        }
    }, [ProfileData?.id]);
    useEffect(() => {
        registerLoadMore(handleInfiniteScroll);
        return () => registerLoadMore(null);
    }, [handleInfiniteScroll, registerLoadMore]);

    return (
        <>
            <div className="container">
                <div className="row">
                    {Data.map((AudiData, index) => (
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-xs-12" key={index} >
                            <div className="card card-style" style={{ backgroundColor: getProjectType(AudiData.audition.project_type) }}>
                                <div className="card-types" style={{ backgroundColor: getProjectTypeColor(AudiData.audition.project_type) }}>{AudiData.audition.project_type ? AudiData.audition.project_type : "---"}</div>
                                {/* <div className="audi-edit">
                                    <Dropdown>
                                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                                            <MdOutlineMoreVert size={25} />
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={() => handleNavigate(Audition.id, "edit")}>Edit</Dropdown.Item>
                                            <Dropdown.Item onClick={() => DeleteAlert(Audition.id)}>Delete</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div> */}
                                <div className='card-content'>
                                    {AudiData.audition.banner_name ? (
                                        <h4 className="banner-title">
                                            {AudiData.audition.banner_name}
                                        </h4>
                                    ) : (
                                        <div style={{ padding: '20px' }}></div>
                                    )}

                                    <div className="card-descrt">
                                        <div className="card-descrt-inner">
                                            <div className="project_title">
                                                <div className="audi-id">RD{AudiData.id && AudiData.id}</div>
                                                <div>
                                                    <div className='Audi-project-title'>{AudiData.audition.project_title && AudiData.audition.project_title}</div>
                                                    <div className='Audi-description'>{AudiData.audition.description && AudiData.audition.description}</div>
                                                </div>
                                            </div>
                                            <div className="card-audi">
                                                {AudiData.audition.platform &&
                                                    <div className="audi-label" style={{ background: '#b00de9' }}>{AudiData.audition.platform}</div>
                                                }
                                                {AudiData.audition.zoner &&
                                                    <div className="audi-label" style={{ background: '#671640' }}>{AudiData.audition.zoner}</div>
                                                }
                                                {AudiData.audition.loc_lang.city &&
                                                    <div className="audi-label" style={{ background: '#3cb371' }}>{AudiData.audition.loc_lang.city}</div>
                                                }
                                                {AudiData.audition.loc_lang.languages &&
                                                    <div className="audi-label" style={{ background: '#db7093' }}>{AudiData.audition.loc_lang.languages}</div>
                                                }
                                            </div>
                                            <div className="card-detail">
                                                <div className="card-botton-centent">
                                                    <div className="card-cont-title">Producer</div>
                                                    <div className='card-cont-detail'>{AudiData.audition.producer_name ? AudiData.audition.producer_name : "-"}</div>
                                                </div>
                                                <div className="card-botton-centent">
                                                    <div className="card-cont-title">Director</div>
                                                    <div className='card-cont-detail'>{AudiData.audition.director_name ? AudiData.audition.director_name : "-"}</div>
                                                </div>
                                                {AudiData.audition.hero && <div className="card-botton-centent">
                                                    <div className="card-cont-title">Hero</div>
                                                    <div className='card-cont-detail'>{AudiData.audition.hero ? AudiData.audition.hero : "-"}</div>
                                                </div>}
                                            </div>
                                            <div className="">
                                                <div className="card-title-custom">Role - {AudiData.character}</div>
                                                <Requirementcontent Audition={AudiData} />
                                            </div>
                                        </div>
                                        <div className="card-bottom">
                                            <div className="card-bottom-inner">
                                                <div className="card-bottom-lefts">
                                                    <div className="card-cont-detail" style={{ display: "flex", alignItems: "center" }}><MdOutlineWatchLater size={20} /><span style={{ marginLeft: "2px" }}>{timeAgo(AudiData?.created_at)}</span></div>
                                                    <div className="card-cont-detail" style={{ display: "flex", alignItems: "center" }}><MdOutlineRemoveRedEye size={20} /><span style={{ marginLeft: "2px" }}>{AudiData.views_count}</span></div>
                                                </div>
                                                <div className="card-bottom-right">
                                                    <button type="button" className="btn btn-primary" onClick={() => handleApply(AudiData.id)}>Apply</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export { ProfileRequirement };